export default {
  tags: {
    default: 'Predefinição',
    visible_to: 'Visível para',
    not_visible_to: 'Não visível para',
  },
  labels: {
    inclusive: 'Incluído',
    exclusive: 'Excluído',
    public: 'Público',
  },
  buttons: {
    edit: 'Editar',
    delete: 'Eliminar',
  },
};
